import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-[#0B1121] py-24">
      <div className="container-custom max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#5CBDB0] hover:underline mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Link>

        <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-8">
          Cookie Policy
        </h1>

        <div className="prose prose-invert prose-lg max-w-none">
          <div className="text-white/70 space-y-6">
            <p className="text-white/50 text-sm">
              Ultimo aggiornamento: 15 Maggio 2026
            </p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                1. Cosa sono i Cookie
              </h2>
              <p>
                I cookie sono piccoli file di testo che i siti web visitati inviano al terminale dell'utente 
                (computer, tablet, smartphone), dove vengono memorizzati per essere poi ritrasmessi agli 
                stessi siti alla visita successiva.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                2. Titolare del Trattamento
              </h2>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">F&P IDEA S.R.L.S.</strong> (marchio DODIPA in concessione esclusiva)</li>
                <li>Sede legale: Corso Pietro Giannone 1/A, 71121 Foggia (FG)</li>
                <li>P.IVA / C.F.: 04328400710</li>
                <li>REA: FG-318897</li>
                <li>Email: info@dodipa.it</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                3. Tipologie di Cookie Utilizzati
              </h2>
              
              <h3 className="font-heading text-xl font-medium text-white mt-6 mb-3">
                3.1 Cookie Tecnici (necessari)
              </h3>
              <p>
                Sono cookie indispensabili per il corretto funzionamento del sito. Permettono la navigazione 
                e l'utilizzo delle funzioni di base. Non richiedono il consenso dell'utente.
              </p>

              <h3 className="font-heading text-xl font-medium text-white mt-6 mb-3">
                3.2 Cookie Analitici
              </h3>
              <p>
                Utilizziamo Google Analytics 4 per raccogliere informazioni, in forma aggregata, sul numero 
                degli utenti e su come questi visitano il sito. I dati sono trattati in forma anonima con 
                IP anonimizzato. Questi cookie vengono installati <strong className="text-white">solo previo 
                consenso esplicito</strong> dell'utente tramite il banner cookie.
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Servizio:</strong> Google Analytics 4</li>
                <li><strong className="text-white">ID Misurazione:</strong> G-27M47EW35D</li>
                <li><strong className="text-white">Fornitore:</strong> Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irlanda</li>
                <li><strong className="text-white">Finalità:</strong> Analisi statistiche delle visite, pagine visualizzate, provenienza utenti</li>
                <li><strong className="text-white">Dati raccolti:</strong> Dati di navigazione anonimi (pagine visitate, durata sessione, dispositivo, area geografica generica)</li>
                <li><strong className="text-white">Durata:</strong> fino a 14 mesi</li>
                <li><strong className="text-white">IP anonimizzato:</strong> Sì</li>
                <li><strong className="text-white">Trasferimento dati extra-UE:</strong> Possibile, con garanzie adeguate (Clausole Contrattuali Standard)</li>
                <li><strong className="text-white">Privacy policy Google:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">policies.google.com/privacy</a></li>
                <li><strong className="text-white">Opt-out:</strong> <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">tools.google.com/dlpage/gaoptout</a></li>
              </ul>

              <h3 className="font-heading text-xl font-medium text-white mt-6 mb-3">
                3.3 Cookie di Terze Parti
              </h3>
              <p>
                Il sito può contenere collegamenti ad altri siti web che dispongono di una propria informativa 
                sulla privacy che può essere diversa da quella del nostro sito.
              </p>
              <p className="mt-4">
                Inoltre, il sito utilizza i seguenti servizi di terze parti che potrebbero installare cookie:
              </p>

              <h4 className="font-heading text-lg font-medium text-[#5CBDB0] mt-4 mb-2">
                Google Fonts
              </h4>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Fornitore:</strong> Google Ireland Limited</li>
                <li><strong className="text-white">Finalità:</strong> Hosting di font per la visualizzazione del sito</li>
                <li><strong className="text-white">Dati raccolti:</strong> Indirizzo IP, dati di utilizzo</li>
                <li><strong className="text-white">Privacy policy:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">policies.google.com/privacy</a></li>
              </ul>

              <h4 className="font-heading text-lg font-medium text-[#5CBDB0] mt-4 mb-2">
                PostHog (Analytics)
              </h4>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Fornitore:</strong> PostHog Inc.</li>
                <li><strong className="text-white">Finalità:</strong> Analisi del comportamento utente per migliorare l'esperienza</li>
                <li><strong className="text-white">Dati raccolti:</strong> Dati di navigazione, interazioni, dati tecnici del dispositivo</li>
                <li><strong className="text-white">Privacy policy:</strong> <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">posthog.com/privacy</a></li>
              </ul>

              <h4 className="font-heading text-lg font-medium text-[#5CBDB0] mt-4 mb-2">
                CDN e Hosting
              </h4>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Finalità:</strong> Distribuzione contenuti, sicurezza, ottimizzazione prestazioni</li>
                <li><strong className="text-white">Dati raccolti:</strong> Indirizzo IP, dati tecnici del browser</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                4. Gestione dei Cookie
              </h2>
              <p>
                L'utente può gestire le preferenze relative ai cookie direttamente all'interno del proprio browser, 
                impedendone l'installazione totale o parziale. Si informa tuttavia che disabilitare i cookie tecnici 
                potrebbe compromettere il corretto funzionamento del sito.
              </p>
              
              <h3 className="font-heading text-xl font-medium text-white mt-6 mb-3">
                Come disabilitare i cookie nei principali browser:
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-white/60">
                <li>
                  <strong className="text-white">Google Chrome:</strong> 
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline ml-1">
                    Guida Chrome
                  </a>
                </li>
                <li>
                  <strong className="text-white">Mozilla Firefox:</strong> 
                  <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline ml-1">
                    Guida Firefox
                  </a>
                </li>
                <li>
                  <strong className="text-white">Safari:</strong> 
                  <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline ml-1">
                    Guida Safari
                  </a>
                </li>
                <li>
                  <strong className="text-white">Microsoft Edge:</strong> 
                  <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline ml-1">
                    Guida Edge
                  </a>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                5. Base Giuridica
              </h2>
              <p>
                La base giuridica per l'utilizzo dei cookie tecnici è il legittimo interesse del Titolare 
                (Art. 6, par. 1, lett. f) GDPR). Per i cookie analitici e di profilazione, la base giuridica 
                è il consenso dell'utente (Art. 6, par. 1, lett. a) GDPR).
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                6. Diritti dell'Utente
              </h2>
              <p>
                L'utente può esercitare i diritti previsti dal GDPR (accesso, rettifica, cancellazione, 
                limitazione, portabilità, opposizione) contattando il Titolare all'indirizzo: 
                <a href="mailto:info@dodipa.it" className="text-[#5CBDB0] hover:underline ml-1">info@dodipa.it</a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                7. Aggiornamenti
              </h2>
              <p>
                La presente Cookie Policy può essere soggetta a modifiche. Si consiglia di consultare 
                periodicamente questa pagina per rimanere aggiornati.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
